module.exports = __webpack_public_path__ + "static/done-779b197b2dd44f4a782b9655de65ddb0.png";